"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KansaResultReferOldContainer = void 0;
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _labelConsts = require("01_core/constants/labelConsts");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _KansaReferOld = _interopRequireDefault(require("./KansaReferOld"));
var _kansaResultReferActions = require("./kansaResultReferActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査結果詳細参照機能コンテナ
 * @prop {object} [loginUserInfo] - 登録対象者情報
 * @prop {string} dispContent - 画面表示情報
 * @prop {object} btnProps - 戻るボタンの情報
 * @prop {string} btnProps.label - 戻るボタンのラベル
 * @prop {func} btnProps.onClick - 戻るボタン押下時の動作
 *
 * シグネチャ（search : boolean）=> {}
 */
class KansaResultReferOldContainer extends _react.default.Component {
  constructor(props) {
    super(props);
    const {
      kansaInfo,
      loginUserInfo,
      setUserInfo,
      setKansaInfo
    } = props;
    setUserInfo(loginUserInfo);
    setKansaInfo(kansaInfo);
  }
  componentWillUnmount() {
    this.props.clear();
  }
  render() {
    const {
      dispContent,
      btnProps,
      intl,
      isNewWindow
    } = this.props;
    if (dispContent === _kansaResultReferActions.CONTENTS.REFER) {
      return /*#__PURE__*/_react.default.createElement(_KansaReferOld.default, {
        returnBtn: className => /*#__PURE__*/_react.default.createElement(_CButton.default, {
          negative: true,
          autoWidth: true,
          className: className,
          onClick: btnProps.onClick(false)
        }, btnProps.label),
        closeBtn: className => /*#__PURE__*/_react.default.createElement(_CButton.default, {
          autoWidth: true,
          className: className,
          onClick: () => {
            window.close();
          },
          negative: true
        }, intl.formatMessage({
          id: _labelConsts.LABEL.CORE_CLOSE
        })),
        isNewWindow: isNewWindow
      });
    }
  }
}
exports.KansaResultReferOldContainer = KansaResultReferOldContainer;
KansaResultReferOldContainer.propTypes = {
  loginUserInfo: _propTypes.default.shape({
    kaishaCd: _propTypes.default.string,
    shainId: _propTypes.default.string,
    shainNm: _propTypes.default.string,
    kaishaNm: _propTypes.default.string,
    soshikiNm: _propTypes.default.string
  }),
  dispContent: _propTypes.default.string,
  btnProps: _propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  }).isRequired
};
const mapStateToProps = state => {
  return {
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    dispContent: state.kansaResultRefer.dispContent
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setUserInfo: userInfo => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_USER_INFO](userInfo)),
    setKansaInfo: kansaInfo => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_KANSA_INFO](kansaInfo)),
    setReturnBtn: btn => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.SET_RETURN_BTN](btn)),
    clear: () => dispatch(_kansaResultReferActions.kansaResultReferActions[_kansaResultReferActions.TYPES.CLEAR]())
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KansaResultReferOldContainer)));